import { takeLatest } from 'redux-saga/effects';

import { GET_INDUSTRIES } from './industries/industriesActions';
import { REQUEST_RELATED_ENTITIES } from './relatedEntities/relatedEntitiesActions';
import { REQUEST_QUESTIONNAIRE_AVAILABILITY } from './questionnaire/questionnaireActions';
import { GET_RATING_COVERAGE } from './ratingCoverage/ratingCoverageAction';
import { GET_ESG_COVERAGE } from './esgCoverage/esgCoverageAction';
import { GET_REGIONS } from './regions/regionsAction';
import { industriesSaga } from './industries/industriesSaga';
import { requestRelatedEntitiesSaga } from './relatedEntities/relatedEntitiesSaga';
import { ratingCoverageSaga } from './ratingCoverage/ratingCoverageSaga';
import { esgCoverageSaga } from './esgCoverage/esgCoverageSaga';
import { regionsSaga } from './regions/regionsSaga';
import { questionnaireSaga } from './questionnaire/questionnaireSaga';

export function* sharedWatchers() {
  yield takeLatest(GET_INDUSTRIES, industriesSaga);
  yield takeLatest(REQUEST_RELATED_ENTITIES, requestRelatedEntitiesSaga);
  yield takeLatest(GET_RATING_COVERAGE, ratingCoverageSaga);
  yield takeLatest(GET_ESG_COVERAGE, esgCoverageSaga);
  yield takeLatest(GET_REGIONS, regionsSaga);
  yield takeLatest(REQUEST_QUESTIONNAIRE_AVAILABILITY, questionnaireSaga);
}
